import {useMemo} from 'react';

import {createTagDescriptionDocument} from './utils';

type TagDescriptionFrameProps = {
  html?: string | null;
};

const TagDescriptionFrame: React.FC<TagDescriptionFrameProps> = ({html}) => {
  const srcDoc = useMemo(() => {
    if (!html?.trim()) return '';

    const theme = getComputedStyle(document.documentElement);
    return createTagDescriptionDocument(html, {
      borderColor: theme.getPropertyValue('--color-gray-03').trim() || 'lightgray',
      headerBackground: theme.getPropertyValue('--color-gray-02').trim() || 'whitesmoke'
    });
  }, [html]);

  if (!srcDoc) return null;

  return (
    <div className="overflow-hidden rounded-lg border border-orange-light-07 bg-orange-wash p-4">
      <iframe
        title="راهنمای موضوع تیکت"
        className="block h-65 w-full shrink-0 border-0 bg-transparent"
        sandbox=""
        referrerPolicy="no-referrer"
        srcDoc={srcDoc}
      />
    </div>
  );
};

export default TagDescriptionFrame;
